import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

export const SessionRedirect = function () {
    let {id,token} = useParams()
    const navigate = useNavigate()
    useEffect(() => {
        token = token.replace(/\*/g, '.');
        localStorage.setItem('token',token)
        localStorage.setItem('userId',id)
        navigate('/map')
    },[])
    
    return (<></>)
}
